module.exports = __webpack_public_path__ + "img/step20_a_printer_basic_remove_tapes.48286eec.png";